import { createVanIconComponent } from "./van"

const Enlarge = createVanIconComponent("enlarge")
export default Enlarge
